import { inject, Service, InjectionToken } from '@angular/core'
import { Permission } from '@seiri/shared/common'

export const GET_PERMISSIONS = new InjectionToken<() => Set<Permission>>('GET_PERMISSIONS')
export const GET_IS_ROOT = new InjectionToken<() => boolean>('GET_IS_ROOT')

@Service()
export class AuthzService {
  private readonly getEffectivePermissions = inject(GET_PERMISSIONS, { optional: false })
  private readonly getIsRoot = inject(GET_IS_ROOT, { optional: true })

  hasPermission(permission: Permission): boolean {
    if (this.getIsRoot?.()) {
      return true
    }
    return this.getEffectivePermissions().has(permission)
  }

  hasAllPermissions(permissions: readonly Permission[]): boolean {
    if (this.getIsRoot?.()) {
      return true
    }
    const effective = this.getEffectivePermissions()
    return permissions.every((p) => effective.has(p))
  }

  hasAnyPermission(permissions: readonly Permission[]): boolean {
    if (this.getIsRoot?.()) {
      return true
    }
    const effective = this.getEffectivePermissions()
    return permissions.some((p) => effective.has(p))
  }
}
